import { z } from 'zod'

export const loViewJwtIssuer = 'admin-api' as const
export const loViewJwtAudience = 'borrower-portal-api' as const

export const loViewTokenTtlSeconds = 60

export const loViewDefaultRoute = '/tasks' as const

export const loViewAsOptions = ['borrower', 'coborrower'] as const
export type LoViewAs = (typeof loViewAsOptions)[number]

export const loViewHandshakeMessageType = 'lo-view:handshake' as const
export const loViewReadyMessageType = 'lo-view:ready' as const

export const loViewTokenPayloadSchema = z.object({
  applicationId: z.number().int().positive(),
  applicationGuid: z.string().uuid(),
  borrowerUserId: z.number().int().positive(),
  viewAs: z.enum(loViewAsOptions),
  loEmail: z.string().email(),
  jti: z.string().uuid(),
  iss: z.literal(loViewJwtIssuer),
  aud: z.literal(loViewJwtAudience),
  exp: z.number(),
  iat: z.number(),
})

export type LoViewTokenPayload = z.infer<typeof loViewTokenPayloadSchema>

export interface LoViewTokenResponse {
  token: string
}

export interface LoViewSessionRequestBody {
  token: string
}

export interface LoViewSessionResponse {
  csrf: string
  applicationGuid: string
  viewAs: LoViewAs
}

export interface LoViewHandshakeMessage {
  type: typeof loViewHandshakeMessageType
  token: string
  viewAs: LoViewAs
  initialRoute?: string
}

export interface LoViewReadyMessage {
  type: typeof loViewReadyMessageType
}
